import React from "react";
import Layout from "../components/layout";
import Gallery from "../components/gallery";
import { graphql } from "gatsby";
import mappings from "../config/gallery-mappings";
import SEO from "../components/seo";

const buildTitle = mapping => mapping.subtitle
  ? `${mapping.label}: ${mapping.subtitle}`
  : mapping.label;

export default ({ data }) => {
  return (
    <>
      <SEO title={buildTitle(mappings[data.allFile.edges[0].node.relativeDirectory])} />
      <Layout>
        <h1 style={{ paddingLeft: "15px" }}>
          {buildTitle(mappings[data.allFile.edges[0].node.relativeDirectory])}
        </h1>
        <Gallery data={data} />
      </Layout>
    </>
  );
};

export const query = graphql`
query($name: String!) {
    allFile (filter: { sourceInstanceName: { eq: "galleries"}, relativeDirectory: {eq: $name}}){
      edges{
        node{
          relativeDirectory
          relativePath
          name
          extension
        }
      }
    }
  }
`;